import i18next from 'i18next';

i18next.addResources('es_CL', 'UnavailableProducts', {
  error: '¡Oh no!',
  unavailable: 'Algunos de tus productos ya no están disponibles.',
  removeProducts: 'Quitar productos y continuar'
});
